import { ApiError } from '@app/api/errors';
import { ReportContext } from '@app/components/reports/types';
import { useGetPurchaseReport } from '@shared/api/hooks/reports/reports';
import { OperationReportsPurchaseResultsRetrieveQueryResult } from '@shared/api/lib/operation-reports/operation-reports';
import { createContext, useContext } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

const PurchaseReportResultContext =
  createContext<ReportContext<OperationReportsPurchaseResultsRetrieveQueryResult> | null>(
    null
  );

export function usePurchaseReportResult() {
  return useContext(
    PurchaseReportResultContext
  ) as ReportContext<OperationReportsPurchaseResultsRetrieveQueryResult>;
}

export default function PurchaseReportContextProvider() {
  const { pathname } = useLocation();
  const params = useParams();
  const report_uuid = params.report_uuid;

  const {
    data: reportResult,
    status: reportResultStatus,
    error: reportResultError,
  } = useGetPurchaseReport(report_uuid!);

  const context: ReportContext<OperationReportsPurchaseResultsRetrieveQueryResult> =
    {
      result: reportResult!,
      resultStatus: reportResultStatus,
      resultError: reportResultError as ApiError,
      downloadMode: pathname.endsWith('/download'),
    };

  return (
    <PurchaseReportResultContext.Provider value={context}>
      <Outlet />
    </PurchaseReportResultContext.Provider>
  );
}
